import {AxiosResponse} from 'axios';
import {isEqual} from 'lodash';

export class VFormData<T> {
  public data: T;
  public errors: {
    [P in keyof T]: string[]
  };
  private readonly originData: T;

  constructor(data: T) {
    this.data = { ...data };
    this.originData = { ...data };
    this.resetErrors();
  }

  public extractErrorsFromResponse(response: AxiosResponse) {
    if (response.status === 422 && response.data && response.data.errors) {
      this.errors = { ...this.errors, ...response.data.errors };
    }
  }

  public resetErrors(targetKey?: keyof T) {
    if (targetKey) {
      this.errors[targetKey] = [];
      return;
    }
    this.errors = {} as any;
    for (const key of Object.keys(this.data)) {
      (this.errors as any)[key] = [];
    }
  }

  public reset() {
    this.data = { ...this.originData };
    this.resetErrors();
  }

  get isDirty() {
    return isEqual(this.originData, this.data);
  }
}
